var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.row.changes),function(change,index){return _c('div',{key:index,staticClass:"mb-4"},[_c('p',{staticClass:"name"},[_vm._v(_vm._s(change.name))]),_c('div',{staticClass:"space-x-4 mt-4 d-flex"},[_c('p',{staticClass:"old-change"},[_vm._v(_vm._s(change.old))]),_c('p',{staticClass:"new-change"},[_vm._v(_vm._s(change.new))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }